// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZlOB","title":"styles_title__3aMic"};